module.exports = __webpack_public_path__ + "static/media/tax.b4b82829.jpg";